import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LiveSessionsService from '../../../Api/LiveSessionsService';

const ViewLiveSessions = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const sessionId = new URLSearchParams(location.search).get('id');
    const sessionsAPI = new LiveSessionsService();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [sessionData, setSessionData] = useState(null);

    useEffect(() => {
        const fetchSession = async () => {
            try {
                setLoading(true);
                const response = await sessionsAPI.GetLiveSessionById(sessionId);
                if (response.data && response.data.data) {
                    setSessionData(response.data.data);
                }
            } catch (err) {
                setError('Failed to load session data. Please try again.');
                console.error('Error loading session:', err);
            } finally {
                setLoading(false);
            }
        };

        if (sessionId) {
            fetchSession();
        } else {
            navigate('/live-sessions-list');
        }
    }, [sessionId, navigate]);

    if (loading) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger m-4" role="alert">
                {error}
            </div>
        );
    }

    if (!sessionData) {
        return (
            <div className="alert alert-warning m-4" role="alert">
                Session not found.
            </div>
        );
    }

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-24">
                    <h4 className="text-xl text-primary-light">View Live Session</h4>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => navigate('/live-sessions-list')}
                    >
                        <Icon icon="mdi:arrow-left" /> Back to List
                    </button>
                </div>

                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="info-group mb-3">
                            <label className="text-muted">Course</label>
                            <p className="h5">{sessionData.Course?.title || 'N/A'}</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Title</label>
                            <p className="h5">{sessionData.title}</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Description</label>
                            <p className="h5">{sessionData.description}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="info-group mb-3">
                            <label className="text-muted">Session Date and Time</label>
                            <p className="h5">{new Date(sessionData.session_datetime).toLocaleString()}</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Duration</label>
                            <p className="h5">{sessionData.session_duration_minutes} minutes</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Status</label>
                            <p className={`h5 ${sessionData.session_url ? 'text-success' : 'text-warning'}`}>
                                {sessionData.session_url ? 'Active' : 'Pending'}
                            </p>
                        </div>

                        {sessionData.session_url && (
                            <div className="info-group mb-3">
                                <label className="text-muted">Session URL</label>
                                <p className="h5">
                                    <a href={sessionData.session_url} target="_blank" rel="noopener noreferrer">
                                        {sessionData.session_url}
                                    </a>
                                </p>
                            </div>
                        )}

                        {sessionData.google_meet_link && (
                            <div className="info-group mb-3">
                                <label className="text-muted">Google Meet Link</label>
                                <p className="h5">
                                    <a href={sessionData.google_meet_link} target="_blank" rel="noopener noreferrer">
                                        {sessionData.google_meet_link}
                                    </a>
                                </p>
                            </div>
                        )}

                        <div className="info-group mb-3">
                            <label className="text-muted">Created At</label>
                            <p className="h5">{new Date(sessionData.created_at).toLocaleString()}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewLiveSessions;

